import request from '@/utils/request'
import { v2Host } from '@/config/host'
import { AxiosPromise } from 'axios'
import { ResponseData } from 'request'
import {
  GamePlayListResponseData,
  ReplayDetailResponseData,
} from '@pt/api/vrecord/gameplay.type'

/**
 * 创建 gameplay 版本
 * http://playable.dev.com:8067/index.html?urls.primaryName=Playturbo%E6%8E%A5%E5%8F%A3%E6%96%87%E6%A1%A3#/vrecord/post_vrecord_gameplay_create
 * @param project_id 项目 id
 * @param name 版本名称
 */
export function create(project_id: number, name?: string): AxiosPromise {
  return request({
    url: `${v2Host}/vrecord/gameplay/create`,
    method: 'post',
    data: {
      project_id,
      name,
    },
  })
}

/**
 * 获取 gameplay 版本的详情数据包含录制数据
 * @param id gameplay 的 id
 */
export function getReplayDetail(
  id: number,
): AxiosPromise<ResponseData<ReplayDetailResponseData>> {
  return request({
    url: `${v2Host}/vrecord/gameplay/detail?id=${id}`,
    method: 'get',
  })
}

/**
 * 保存 gameplay 版本的录制数据
 * @param data.duration 试玩时长
 * @param data.id 版本 id
 * @param data.name 版本名称
 * @param data.orientation 版本横竖屏
 * @param data.params 版本中应用的动态参数，json 字符串
 * @param data.replay 版本中用户的行为数据，json 字符串
 * @param data.cursor_file 版本中用户上传的光标图标 file_path
 * @param data.cover 封面图 base64
 */
export function saveReplay(data: {
  id: number
  duration?: number
  name?: string
  orientation?: number
  params?: string
  replay?: string
  cursor_file?: string
  cover?: string
}): AxiosPromise<ResponseData<string>> {
  return request({
    url: `${v2Host}/vrecord/gameplay/save`,
    method: 'post',
    data,
  })
}

/**
 * 获取 gameplay 版本数据
 * @param data.pid 项目 的 id
 */
export function gameplayList(data: {
  pid: number
  page?: number
  page_size?: number
  search_field?: string
  keyword?: string
  order?: string
  status?: string
}): AxiosPromise<ResponseData<GamePlayListResponseData>> {
  return request({
    url: `${v2Host}/vrecord/gameplay/list`,
    method: 'get',
    params: data,
  })
}

/**
 * 删除 gameplay 版本数据
 * @param id 版本 的 id
 */
export function gameplayDelete(id: number): AxiosPromise {
  return request({
    url: `${v2Host}/vrecord/gameplay/delete?id=${id}`,
    method: 'post',
  })
}

/**
 * 复制 gameplay 版本数据
 * @param id 版本 的 id
 * @param name 版本名称
 */
export function gameplayCopy(id: number, name?: string): AxiosPromise {
  return request({
    url: `${v2Host}/vrecord/gameplay/copy`,
    method: 'post',
    data: {
      id,
      name,
    },
  })
}

export function gameplayRender(data: {
  id: number
  name: string
  resolution: string
}): AxiosPromise<ResponseData<string>> {
  return request({
    url: `${v2Host}/vrecord/gameplay/render`,
    method: 'post',
    data,
  })
}
